<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" focusable="false" class="icon__symbol">
  <use attr.xlink:href="assets/icons/sprite/sprite.svg#{{ icon }}"></use>
</svg>
